<div #mainContainer class="EFMain EFMain--{{appMode == null ? '' : appMode.toUpperCase()}} {{ isPortrait ? 'EFMain--Portrait' : 'EFMain--Landscape' }}" (click)="resetInactivity()" (mousemove)="resetInactivity()">
    @if (isLoading || isLoadingProducts || isLoadingDetail) {
        <app-pg-loading [isLarge]="true" [isOverlay]="true"></app-pg-loading>
    }
    @if (!isLoading) {
        <div class="EFMain-Inner bg-light">
            @if (hasBack) {
                <button type="button" class="btn btn-white EFMain-Back" (click)="goBack.emit()" [attr.aria-label]="'experience-finder.a11y.back' | locTranslate">
                    <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </button>
            }
            <div class="EFMain-Center">
                <div class="EFMain-Section" role="navigation" [attr.aria-label]="'experience-finder.a11y.section-nav' | locTranslate">
                    @if (!lockSection && (!modalProductTarget || !modalProductTarget.hasItinerary())) {
                        @for (section of sectionList; track section) {
                            <button type="button" class="btn btn-white EFMain-Section-Button {{ currentSection == section ? 'btn-white-selected' : '' }}" (click)="goToSection(section)" [attr.aria-current]="currentSection == section ? 'page' : null">
                                <span>{{ 'experience-finder.ef-main.nav-' + section | locTranslate }}</span>
                            </button>
                        }
                    }
                    @if (modalProductTarget && modalProductTarget.hasItinerary()) {
                        <button type="button" class="btn btn-white float-start EFMain-Section-Button" (click)="modalProductBack()">
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            <span>{{ 'experience-finder.ef-main.nav-back' | locTranslate }}</span>
                        </button>
                    }
                </div>
                <div class="EFMain-Content">
                    <div class="EFMain-Content-Main">
                        <div class="EFMain-Content-Main-Center">
                            @if (!modalProductTarget || !modalProductTarget.hasItinerary()) {
                                <div class="EFMain-Content-Filter {{ currentSection == 'map' ? 'EFMain-Content-Filter--Overlay' : 'container p-0'}}">
                                    <app-ef-filter #filterComponent [(filterData)]="filterData" (filterDataChange)="onFilterDataChange()" [lockFilter]="lockFilter" [lockFilterType]="lockFilterType" [lockPast]="lockPast" [section]="currentSection" [availableTypes]="availableTypes" [mixTypes]="mixTypes" (centerMap)="centerMap()" (requestCumulativeBooking)="doCumulativeBooking()"></app-ef-filter>
                                </div>
                                <div class="EFMain-Content-Map" [attr.aria-hidden]="currentSection != 'map'">
                                    <app-ef-map #efMapComponent [hidden]="currentSection != 'map'" [productsData]="getCurrentProductsData()" [productsHighlight]="productsHighlight" (showProduct)="onShowProduct($event)"
                                    (mapBoundsChange)="onMapBoundsChange($event)" [mapBounds]="mapBounds"></app-ef-map>
                                </div>
                                @if (currentSection == 'list') {
                                    <div class="EFMain-Content-List">
                                        <div class="container p-0">
                                            <app-ef-list [full]="true" [productsData]="filteredProductsData" (showProduct)="onShowProduct($event)"></app-ef-list>
                                        </div>
                                    </div>
                                }
                                @if (currentSection == 'calendar') {
                                    <div class="EFMain-Content-Calendar">
                                        <div class="container p-0">
                                            @if (currentSection == 'calendar') {
                                                <app-ef-calendar [productsData]="filteredProductsData" (showProduct)="onShowProduct($event)"></app-ef-calendar>
                                            }
                                        </div>
                                    </div>
                                }
                            }
                            @if (modalProductTarget && modalProductTarget.hasItinerary()) {
                                <div class="EFMain-Content-Itinerary">
                                    <app-ef-product-map [hideList]="true" [productData]="modalProductTarget" (showProduct)="onShowProduct(modalProductTarget.id + '/' + $event)"></app-ef-product-map>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            @if (currentSection == 'map' || isLoadingDetail || modalProductTarget) {
                <div class="EFMain-Side">
                    <div class="EFMain-Side-Main">
                        @if (getCurrentProductsData(true); as productsData) {
                            <div class="bg-light">
                                <app-ef-list [vertical]="!isPortrait" [productsData]="productsData" (showProduct)="onShowProduct($event)"></app-ef-list>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        @if (hasOperatorsBanner) {
            <div class="EFMain-Footer pb-2 bg-light">
                <small class="mx-2" [innerHTML]="'experience-finder.ef-main.operators-banner-access' | locTranslate:'login':formsUrl:'info':manualUrl"></small>
                @if (contactEmail) {
                    <small class="mx-2" [innerHTML]="'experience-finder.ef-main.operators-banner-contact' | locTranslate:'email':contactEmail"></small>
                }
            </div>
        }
        @if (modalProductTarget) {
            <div class="EFModal EFModal--Product bg-light {{ !isPortrait ? 'EFModal--Lanscape' : '' }} pg-animation-slideup" role="dialog" aria-modal="true" [attr.aria-label]="modalProductTarget.getTranslatedProductField('title') | stripHTML">
                <div class="EFModal-Body">
                    <app-ef-product [productData]="modalProductTarget" [supplierData]="modalSupplierTarget" [POIData]="modalPOITarget" [appMode]="appMode" (showProduct)="onShowProduct($event)" [oneColumn]="true"
                    [hasBack]="!modalProductTarget.hasItinerary()" (goBack)="modalProductBack()"></app-ef-product>
                </div>
            </div>
        }
    }

    @if (showScreensaver) {
        <div class="EFMain-Screensaver">
            <app-ef-screensaver [showQR]="hasShowcaseWithQR" [showcaseContent]="showcaseContent"></app-ef-screensaver>
        </div>
    }
</div>
